export default {
  namespaced: true,
  state: {
    models: [],
    current_model: null,
  },
  getters: {
    currentModel: state => state.current_model,
  },
  mutations: {
    // eslint-disable-next-line no-shadow
    SET_ALL_MODELS(state, payload) {
      state.models = payload
    },
    SET_CURRENT_MODEL(state, payload) {
      state.current_model = payload
    },
  },
  actions: {
    getModels: async ({ commit }) => {
      try {
        const data = await window.http.get('models')
        commit('SET_ALL_MODELS', data)
        return data
      } catch (error) {
        return error
      }
    },
    setModels: async ({ commit }, data) => {
      commit('SET_ALL_MODELS', data)
    },

    getModel: async ({ commit }, uuid) => {
      const data = await window.http.get(`models/${uuid}`)
      if (data.error) {
        return null
      }
      commit('SET_CURRENT_MODEL', data)
      return data
    },
  },
}
